export const STATUS_LABELS = {
  draft: "Черновик",
  posted: "Проведено",
  cancelled: "Отменено",
};

// Причины совпадают с `InventoryDiffReason` на бэкенде (общие с ревизией).
export const REASON_LABELS = {
  loss_theft: "Кража",
  loss_damage: "Ущерб",
  loss_expired: "Истекший срок",
  loss_accounting_error: "Бухгалтерская ошибка",
  surplus_return: "Возврат брак",
  other: "Другое",
};

export const REASON_OPTIONS = Object.entries(REASON_LABELS).map(([value, label]) => ({ value, label }));

export function statusColor(status) {
  if (status === "posted") return "var(--c-success)";
  if (status === "cancelled") return "var(--c-danger)";
  return "var(--c-text-sub)";
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("ru-RU");
}

/** Текст ошибки бэкенда: `detail` и построчные проблемы `items`. */
export function describeError(payload) {
  if (!payload) return "Не удалось выполнить действие";
  if (typeof payload === "string") return payload;
  const parts = [];
  if (payload.detail) parts.push(String(payload.detail));
  if (Array.isArray(payload.items)) {
    payload.items.forEach((p) => {
      if (p && typeof p === "object" && p.detail) {
        const who = p.product_name ? `${p.product_name} (${p.store_name})` : `товар #${p.product}, магазин #${p.store}`;
        parts.push(`• ${who}: ${p.detail}`);
      }
    });
  }
  if (!parts.length) {
    Object.entries(payload).forEach(([k, v]) => parts.push(`${k}: ${JSON.stringify(v)}`));
  }
  return parts.join("\n") || "Не удалось выполнить действие";
}
